import {
  type BillingResolvedCredential,
  resolveBillingCredential,
} from "../../credentials.ts";
import { resolveBillingEnvironment } from "../../environment.ts";
import type {
  BillingProviderBinding,
  BillingProviderExecutionContext,
} from "./types.ts";

export function createBillingProviderExecutionContext(input: {
  binding: BillingProviderBinding;
  idempotencyKey?: string;
  ingress?: { classicWebhookUrl?: string };
  operationScope?: "organization" | "profile" | "automatic";
  signal?: AbortSignal;
  target?: { profileId?: string };
  testMode?: boolean;
}): BillingProviderExecutionContext {
  const environment = resolveBillingEnvironment({
    testMode: input.testMode,
  });
  const resolved = resolveBillingCredential({
    binding: input.binding,
    provider: input.binding.provider,
    testMode: environment.testMode,
  });
  const credential: BillingResolvedCredential = resolved.credential;
  return {
    binding: input.binding,
    credential,
    environment,
    provider: input.binding.provider,
    ...(input.operationScope === null
      ? {}
      : { operationScope: input.operationScope }),
    idempotencyKey: input.idempotencyKey,
    signal: input.signal,
    target: {
      profileId: input.target?.profileId,
    },
    ...(input.ingress ? { ingress: input.ingress } : {}),
  };
}
